<template>
  <div>
    <Head title="Mail Templates" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/settings">Settings</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Mail Settings</li>
      </ol>
    </nav>
    <h1>Mail PDFs</h1>
    <div class="d-flex justify-content-between mb-3">
      <Link class="btn btn-primary" href="/settings/mail/pdfs/create">
        <span>Create Mail PDF</span>
      </Link>
    </div>
    <div class="content-box">
      <table class="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>File</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="pdf in mail_pdfs.data" :key="pdf.id">
            <td>
              <Link :href="`/settings/mail/pdfs/${pdf.id}/edit`">
                {{ pdf.name }}
              </Link>
            </td>
            <td>
              <a :href="`/${pdf.file}`" target="_blank">{{ pdf.file }}</a>
            </td>
          </tr>
          <tr v-if="mail_pdfs.data.length === 0">
            <td colspan="2">No pdfs found.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <pagination class="mt-3" :links="mail_pdfs.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    customer_templates: Object,
    agency_templates: Object,
    inserts_customer: Object,
    inserts_operator: Object,
    mail_pdfs: Object
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/settings', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
